// extracted by mini-css-extract-plugin
module.exports = {"filters":"SalonOfferFilters_filters___4jqJ"};